var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_c('h5',[_vm._v("Útgáfa 1.0.0")]),_c('p',[_vm._v("Ný útgáfa hefur verið sett inn")])])])
}]

export { render, staticRenderFns }